import React, {useEffect, useState} from "react";
import {Col, Row, Card, Button, Icon} from "antd";
import {FormattedMessage} from "react-intl";
import videoContentsApi from '@api/video-content'
import {BASE_URL} from "../../api/httpRequest";
import {useSelector} from 'react-redux';
import VideoContentsDashboardSearch from "../../components/video-contents/Dashboard/Search";
import ReportList from '../../components/video-contents/Dashboard/List';
import ReportsChart from '../../components/video-contents/Dashboard/Chart';


function VideoContentDashboardPage() {
  const [state, setState] = useState({
    isFetched: false,
    downloadUrl: "",
    data : []
  });
  
  const access_token = useSelector(state => state.auth.access_token);
  
  useEffect(() => {
    fetch()
  }, []);
  
  const fetch = (searchParams={}) => {
    let url = `${BASE_URL}/video-contents/most-viewed/_report`;
    const {["count"]: omit, ...rest } = searchParams || {};
    url += `?${new URLSearchParams({...rest, access_token}).toString()}`;
  
    videoContentsApi.getDashboardReport({
        params: {
          ...searchParams
        }
      })
      .then(({data, meta}) => {
        setState({
          isFetched: true,
          downloadUrl: url,
          data
        })
      })
      .catch()
  };
  
  return (
    <Row gutter={16}>
      {!!state.downloadUrl && (
        <Col span={24}>
          <div className={'report'}>
            <a href={state.downloadUrl}>
              <Button type={"primary"}>
                <Icon type="file-excel"/>
                <FormattedMessage
                  id="app.download_excel_file"
                  defaultMessage={`Download Excel File`}
                />
              </Button>
            </a>
          </div>
        </Col>
      )}
  
      <Col span={24}>
        <Card className={`page-table-header`} bordered={false}>
          <VideoContentsDashboardSearch search={fetch}/>
        </Card>
      </Col>
      <Col span={24}>
        {state.data.length > 0 && <ReportsChart data={state.data}/>}
        
        <ReportList
          loading={!state.isFetched}
          data={state.data}/>
      </Col>
    </Row>
  )
}

export default VideoContentDashboardPage;

